import {
  getPartnerTrackingLinksRequest,
  getPartnerTrackingLinksFailure,
  getPartnerTrackingLinksSuccess,
  getPartnerTrackingStatsRequest,
  getPartnerTrackingStatsSuccess,
  getPartnerTrackingStatsFailure,
  getPartnerCommissionRequest,
  getPartnerCommissionSuccess,
  getPartnerCommissionFailure,
  removePartnerCommissionRequest,
  removePartnerCommissionSuccess,
  removePartnerCommissionFailure,
  getPartnerPaymentRequest,
  getPartnerPaymentSuccess,
  getPartnerPaymentFailure,
  getPartnerSummaryRequest,
  getPartnerSummarySuccess,
  getPartnerSummaryFailure,
  createPartnerPaymentRequest,
  createPartnerPaymentSuccess,
  createPartnerPaymentFailure,
  updatePartnerPaymentSuccess,
  updatePartnerPaymentFailure,
  updatePartnerPaymentRequest,
  removePartnerPaymentRequest,
  removePartnerPaymentSuccess,
  removePartnerPaymentFailure,
  getCouponRequest,
  getCouponSuccess,
  getCouponFailure,
  createCouponSuccess,
  createCouponFailure,
  updateCouponSuccess,
  updateCouponFailure,
  createCouponRequest,
  updateCouponRequest,
  removeCouponRequest,
  removeCouponSuccess,
  removeCouponFailure,
  createShortLinkRequest,
  createShortLinkSuccess,
  createShortLinkFailure,
  updateW9FormRequest,
  updateW9FormSuccess,
  updateW9FormFailure,
  getW9FormRequest,
  getW9FormSuccess,
  getW9FormFailure,
} from "./partnerDetailsSlice";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  createCoupon,
  createPartnerPayment,
  createShortLink,
  getCoupon,
  getPartnerCommission,
  getPartnerPayment,
  getPartnerSummary,
  getPartnerTrackingLinks,
  getPartnerTrackingStats,
  getW9Form,
  removeCoupon,
  removePartnerCommission,
  removePartnerPayment,
  updateCoupon,
  updatePartnerPayment,
  updateW9Form,
} from "./partnerDetailsApi";
import { handleErrorSaga } from "../../utils/helper";

let payloadPartnerSummary;
let payloadPartnerCommission;
let payloadPartnerPayment;

function* handleGetPartnerTrackingLinks({ payload }) {
  try {
    const res = yield call(getPartnerTrackingLinks, payload);
    yield put(getPartnerTrackingLinksSuccess(res.data));
  } catch (error) {
    yield put(getPartnerTrackingLinksFailure());
    yield handleErrorSaga(error);
  }
}

function* handleGetPartnerTrackingStats({ payload }) {
  try {
    const res = yield call(getPartnerTrackingStats, payload);
    yield put(getPartnerTrackingStatsSuccess(res.data));
  } catch (error) {
    yield put(getPartnerTrackingStatsFailure());
    yield handleErrorSaga(error);
  }
}

function* handleGetPartnerCommission({ payload }) {
  payloadPartnerCommission = payload;
  try {
    const res = yield call(getPartnerCommission, payload);
    yield put(getPartnerCommissionSuccess(res.data));
  } catch (error) {
    yield put(getPartnerCommissionFailure());
    yield handleErrorSaga(error);
  }
}

function* handleGetPartnerPayment({ payload }) {
  payloadPartnerPayment = payload;
  try {
    const res = yield call(getPartnerPayment, payload);
    yield put(getPartnerPaymentSuccess(res.data));
  } catch (error) {
    yield put(getPartnerPaymentFailure());
    yield handleErrorSaga(error);
  }
}

function* handleGetPartnerSummary({ payload }) {
  payloadPartnerSummary = payload;
  try {
    const res = yield call(getPartnerSummary, payload);
    yield put(getPartnerSummarySuccess(res.data));
  } catch (error) {
    yield put(getPartnerSummaryFailure());
    yield handleErrorSaga(error);
  }
}

function* handleCreatePartnerPayment({ payload }) {
  try {
    const res = yield call(createPartnerPayment, payload);
    yield put(createPartnerPaymentSuccess(res.data));
    yield put(getPartnerSummaryRequest(payloadPartnerSummary));
  } catch (error) {
    yield put(createPartnerPaymentFailure());
    yield handleErrorSaga(error);
  }
}

function* handleUpdatePartnerPayment({ payload }) {
  try {
    yield call(updatePartnerPayment, payload);
    yield put(updatePartnerPaymentSuccess());
    yield put(getPartnerPaymentRequest(payloadPartnerPayment));
    yield put(getPartnerSummaryRequest(payloadPartnerSummary));
  } catch (error) {
    yield put(updatePartnerPaymentFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemovePartnerCommission({ payload }) {
  try {
    yield call(removePartnerCommission, payload._id);
    yield put(removePartnerCommissionSuccess());
    yield put(getPartnerCommissionRequest(payloadPartnerCommission));
    yield put(getPartnerSummaryRequest(payloadPartnerSummary));
  } catch (error) {
    yield put(removePartnerCommissionFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemovePartnerPayment({ payload }) {
  try {
    yield call(removePartnerPayment, payload._id);
    yield put(removePartnerPaymentSuccess());
    yield put(getPartnerPaymentRequest(payloadPartnerPayment));
    yield put(getPartnerSummaryRequest(payloadPartnerSummary));
  } catch (error) {
    yield put(removePartnerPaymentFailure());
    yield handleErrorSaga(error);
  }
}

function* handleGetCoupon({ payload }) {
  try {
    const res = yield call(getCoupon, payload);
    yield put(getCouponSuccess(res.data));
  } catch (error) {
    yield put(getCouponFailure());
    yield handleErrorSaga(error);
  }
}

function* handleCreateCoupon({ payload }) {
  try {
    const res = yield call(createCoupon, payload);
    yield put(createCouponSuccess(res.data));
  } catch (error) {
    yield put(createCouponFailure());
    yield handleErrorSaga(error);
  }
}

function* handleUpdateCoupon({ payload }) {
  try {
    const res = yield call(updateCoupon, payload);

    const temp = yield select((state) => state.partnerDetailsState.listCoupon);
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload._id);
    const dataIndex = { ...data[index] };
    index >= 0 && data.splice(index, 1);
    data.unshift({ dataIndex, ...res.data });

    yield put(updateCouponSuccess([...data]));
  } catch (error) {
    yield put(updateCouponFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemoveCoupon({ payload }) {
  try {
    yield call(removeCoupon, payload._id);

    const temp = yield select((state) => state.partnerDetailsState.listCoupon);
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload._id);
    index >= 0 && data.splice(index, 1);

    yield put(removeCouponSuccess([...data]));
  } catch (error) {
    yield put(removeCouponFailure());
    yield handleErrorSaga(error);
  }
}

function* handleCreateShortLink({ payload }) {
  try {
    const res = yield call(createShortLink, payload);

    const temp = yield select(
      (state) => state.partnerDetailsState.listPartnerTrackingLink
    );
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload.trackingLinkId);
    index >= 0 && (data[index] = { ...data[index], shortLink: [res.data] });

    yield put(createShortLinkSuccess(data));
  } catch (error) {
    yield put(createShortLinkFailure(error));
    if (error.response.data?.code === "ALIAS_CREATED") {
      return "ALIAS_CREATED";
    }
    yield handleErrorSaga(error);
  }
}

function* handleGetW9Form({ payload }) {
  try {
    const res = yield call(getW9Form, payload);
    yield put(getW9FormSuccess(res.data));
  } catch (error) {
    yield put(getW9FormFailure());
    yield handleErrorSaga(error);
  }
}

function* handleUpdateW9Form({ payload }) {
  try {
    const res = yield call(updateW9Form, payload);
    yield put(updateW9FormSuccess(res.data));
  } catch (error) {
    yield put(updateW9FormFailure());
    yield handleErrorSaga(error);
  }
}

export default function* partnerDetailsSaga() {
  yield takeLatest(
    getPartnerTrackingLinksRequest.type,
    handleGetPartnerTrackingLinks
  );
  yield takeLatest(
    getPartnerTrackingStatsRequest.type,
    handleGetPartnerTrackingStats
  );
  yield takeLatest(
    getPartnerCommissionRequest.type,
    handleGetPartnerCommission
  );
  yield takeLatest(getPartnerPaymentRequest.type, handleGetPartnerPayment);
  yield takeLatest(getPartnerSummaryRequest.type, handleGetPartnerSummary);
  yield takeLatest(
    createPartnerPaymentRequest.type,
    handleCreatePartnerPayment
  );
  yield takeLatest(
    updatePartnerPaymentRequest.type,
    handleUpdatePartnerPayment
  );
  yield takeLatest(
    removePartnerCommissionRequest.type,
    handleRemovePartnerCommission
  );
  yield takeLatest(
    removePartnerPaymentRequest.type,
    handleRemovePartnerPayment
  );
  yield takeLatest(getCouponRequest.type, handleGetCoupon);
  yield takeLatest(createCouponRequest.type, handleCreateCoupon);
  yield takeLatest(updateCouponRequest.type, handleUpdateCoupon);
  yield takeLatest(removeCouponRequest.type, handleRemoveCoupon);
  yield takeLatest(createShortLinkRequest.type, handleCreateShortLink);
  yield takeLatest(getW9FormRequest.type, handleGetW9Form);
  yield takeLatest(updateW9FormRequest.type, handleUpdateW9Form);
}
